module.exports = __webpack_public_path__ + "static/media/scheme1.a848d6ca.png";